exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".search-layout{display:inline-block;background-color:rgba(0,0,0,.8);height:66vh;overflow-y:auto;font-size:16px;width:100%;color:#999;text-align:center;border:1px solid #666;border-left:0;border-right:0;margin-top:-2px;padding:15px}td{text-align:left;width:200px;padding-top:5px;padding-left:15px;padding-right:15px}#table-headings{padding-top:10px;padding-bottom:10px;color:#ffc000;height:40px}@media(max-width: 767px){.search-layout{overflow-x:auto}td,#table-headings th{white-space:nowrap;width:auto;padding-left:8px;padding-right:8px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/BasicSearchTable/styles.scss
// module id = 832
// module chunks = 0